import React from "react";

const CaptachError = ({ setIsCaptchaValid }) => {
  return (
    <>
      <div className="signinup-error-message-modal">
        <div className="signinup-error-message-container">
          <div>
            <span className="font-dark-blue1">
              Erreur de CAPTCHA, vérifiez votre saisie.
            </span>
          </div>

          <div
            className="signinup-error-message-close-button-container"
            onClick={() => setIsCaptchaValid(true)}
          >
            <button>Fermer</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptachError;
